import './MessagesBanner.scss';

import cn from 'classnames';
import React, { useMemo } from 'react';
import Slider from 'react-slick';

import ExternalLink from '@/common/components/atoms/ExternalLink/ExternalLink';
import ButtonClose from '@/common/components/molecules/ButtonClose/ButtonClose';
import { NEXT, PREV } from '@/common/constants';
import CustomArrow from '@/ebat/components/blocks/Common/Slider/CustomArrow/CustomArrow';
import { useBannerContext } from '@/ebat/contexts/BannerContext';
import useMessagesBanner from '@/ebat/hooks/messages-banner/useMessagesBanner';

import {
  MessagesBannerDefaultProps,
  MessagesBannerPropTypes,
} from './MessagesBanner.proptypes';

const MessagesBanner = ({ className }) => {
  const { handleHideBanner, isHiddenBanner } = useBannerContext();

  const { data: messagesBanner } = useMessagesBanner({});

  /**
   * Get sliders settings
   * @type {object}
   */
  const getSliderSettings = useMemo(
    () => ({
      arrows: true,
      dots: false,
      infinite: true,
      prevArrow: <CustomArrow type={PREV} />,
      nextArrow: <CustomArrow type={NEXT} />,
      slidesToShow: 1,
    }),
    [],
  );

  if (!isHiddenBanner && messagesBanner?.data.length > 0) {
    return (
      <div className={cn('messages-banner', className)}>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <Slider {...getSliderSettings} className="messages-banner__list">
          {messagesBanner.data.map((message) => (
            <div
              className="messages-banner__item"
              key={`messages-banner-item-${message.id}`}
            >
              <div className="message">
                <span className="message__title">{message.title}</span>
                {message.link && message.label && (
                  <ExternalLink href={message.link} className="message__link">
                    {message.label}
                  </ExternalLink>
                )}
              </div>
            </div>
          ))}
        </Slider>
        <ButtonClose
          className="messages-banner__close"
          context="messages-banner-close"
          onClick={handleHideBanner}
        />
      </div>
    );
  }

  return null;
};

MessagesBanner.defaultProps = {
  ...MessagesBannerDefaultProps,
};

MessagesBanner.propTypes = {
  ...MessagesBannerPropTypes,
};

export default MessagesBanner;
